import { QUALIFICATION_CODES } from '../../../../../shared/constants/qualification-code';
import { CriteriaQuota } from '../../../../../shared/interfaces/feasibility.interface';
import { Criteria } from '../../../../../shared/interfaces/qualification.interface';
import {
  AudienceQualificationFormatter,
  StringFormatter,
} from '../../feasibility/feasibility.class';

export class Audience {
  public get qualification() {
    return this._qualification.qualification_name;
  }

  public get conditions() {
    const formatter = new AudienceQualificationFormatter(
      this._stringFormatter()
    );
    if (
      this._qualification.qualification_code === QUALIFICATION_CODES.ZIPCODE &&
      this._qualification.condition_codes
    ) {
      return `${this._qualification.condition_codes?.length} codes uploaded`;
    }

    if (this._qualification.condition_names) {
      return formatter.formatAudience(this._qualification.condition_names);
    }

    return formatter.formatRange(this._qualification.range_sets![0]);
  }

  constructor(
    private readonly _qualification: Criteria,
    private readonly _currency: string
  ) {}

  private _stringFormatter() {
    return this._qualification.qualification_code === QUALIFICATION_CODES.INCOME
      ? new StringFormatter(this._currency, ` - ${this._currency}`)
      : undefined;
  }
}

export class AudienceExtractor {
  constructor(
    private readonly _quotas: Criteria[],
    private readonly _quotasSet: Map<number, CriteriaQuota[]>,
    private readonly _currency: string
  ) {}

  public extract() {
    const quotaSet = this._normalize();

    // don't show in audience if there's quotas for the qualification
    return this._quotas.map((quota) => new Audience(quota, this._currency));
  }

  // The default is show age as default quota in the quota list
  // because quotaSet always comes with age qualification when no quotas are set
  private _normalize() {
    const single = this._quotasSet.size === 1;
    const age = this._quotasSet.get(QUALIFICATION_CODES.AGE);

    return single && age ? new Map() : this._quotasSet;
  }
}
